import { render } from "./ShortStay.vue?vue&type=template&id=48d04eb3"
import script from "./ShortStay.vue?vue&type=script&lang=js"
export * from "./ShortStay.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__